'use client';
import React, { createContext, useContext, useState, useEffect } from 'react';
import { RoleId, ROLE_CONFIGS, ROLE_EMAIL_MAP, RoleConfig } from '@/lib/roleConfig';

interface RoleContextValue {
  roleId: RoleId;
  roleConfig: RoleConfig;
  setRole: (id: RoleId) => void;
}

const RoleContext = createContext<RoleContextValue>({
  roleId: 'investor',
  roleConfig: ROLE_CONFIGS['investor'],
  setRole: () => {},
});

export function RoleProvider({ children }: { children: React.ReactNode }) {
  const [roleId, setRoleId] = useState<RoleId>('investor');

  useEffect(() => {
    const stored = localStorage.getItem('halalcham_role') as RoleId | null;
    if (stored && ROLE_CONFIGS[stored]) {
      setRoleId(stored);
    }
  }, []);

  const setRole = (id: RoleId) => {
    setRoleId(id);
    localStorage.setItem('halalcham_role', id);
  };

  return (
    <RoleContext.Provider value={{ roleId, roleConfig: ROLE_CONFIGS[roleId], setRole }}>
      {children}
    </RoleContext.Provider>
  );
}

export function useRole() {
  return useContext(RoleContext);
}

export { ROLE_EMAIL_MAP };
